// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"c9c75db2","239":"5211a6c8","453":"f447ec5a","455":"81daa878","977":"307d22e3"}[chunkId] + ".chunk.js";
};